import Script from 'next/script';
import { MEDALLIA_SCRIPT_SRC } from '../../constants/medallia';

export function MedalliaScript() {
    return MEDALLIA_SCRIPT_SRC ? <Script data-testid="medallia-script" async src={MEDALLIA_SCRIPT_SRC} /> : null;
}
